
const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className="flex flex-col space-y-4">
        <a href="tel:08503462772" className="bg-cyan-500 text-white p-4 rounded-full shadow-lg hover:bg-cyan-600 transition-colors">
          <i className="ri-phone-line text-xl"></i>
        </a>
        <a href="mailto:assa@assaisg.com" className="bg-sky-500 text-white p-4 rounded-full shadow-lg hover:bg-sky-600 transition-colors">
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a href="https://wa.me/905531333536" target="_blank" rel="noopener noreferrer" className="bg-orange-500 text-white p-4 rounded-full shadow-lg hover:bg-orange-600 transition-colors">
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
      </div>
    </div>
  );
};

export default FloatingButtons;
